<template>
  <modal :name="'modal-subscription'" :width="520">
    <div slot="content">
      <i
        slot="close"
        class="modal-close icon-close h2 cl-black pointer"
        @click="close"
        data-testid="closeModalButton"
      />
      <h1 class="uppercase center-xs modal-title mb0 weight-400">
        {{ $t('Premium subscription') }}
      </h1>
      <p class="fs-medium-small align-center mt10">
        {{ $t('The subscription has been added to the cart - pay for the order to be able to rent as part of the subscription.') }}
      </p>
      <button-full-rectangonal class="w-100" :disabled="false" @click.native="goToCheckout">
        {{ $t('Pay for the order') }}
      </button-full-rectangonal>
    </div>
  </modal>
</template>

<script>
import Modal from 'theme/components/core/Modal.vue'
import ButtonFullRectangonal from 'src/themes/theme-egarderobe/components/theme/ButtonFullRectangonal.vue'

export default {
  name: 'SubscriptionModal',
  components: {
    Modal,
    ButtonFullRectangonal
  },
  methods: {
    goToCheckout () {
      this.$router.push(this.localizedRoute('/checkout'))
      this.close()
    },
    close () {
      this.$bus.$emit('modal-hide', 'modal-subscription')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-content{
  padding: 0;
}
.icon-close {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 36px;
}
.modal-title {
  word-spacing: 100vw;
}
</style>
